import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import BredcomSlider from '../Bredcom/MainSlider'
import NewMain from '../headerone/newMain'



function MVNTimes() { 
  return (
    <>
    
      <NewMain />
        <Bredcom title="Home" subtitle="MVN Times" />
        <section className="about-area about-p pt-60 pb-60 p-relative fix">
          <div className="container">
            <h2 class="text-center"> MVN Times </h2>
            <br/>

            <table class="table table-bordered">
    <thead class="table-light head_red">
        <tr>
            <th scope="col">Sr. No.</th>
            <th scope="col">Name</th>
            <th scope="col">Link</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>1</td>
            <td>MVN Newsletter – Volume 3 </td>
            <td><a href="/MVN_News_Letter_Vol_3.pdf" target='_blank' >View </a></td>
        </tr>
         
    </tbody>
</table>




          </div>
          
        </section>
    </>
  )
}

export default MVNTimes